module.exports = __webpack_public_path__ + "img/page6.8a2e9a78.png";